"use strict";
/**
 * Copyright © 2019 - Present, VamStar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarMode = void 0;
const react_1 = __importStar(require("react"));
const makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
const withStyles_1 = __importDefault(require("@mui/styles/withStyles"));
const material_1 = require("@mui/material");
const calendar_mode_1 = require("./calendar-mode");
const GROUP_MARGIN = 0.5;
const useStyles = makeStyles_1.default((theme) => ({
    paper: {
        backgroundColor: theme.palette.black['600'],
        width: 'fit-content',
        borderRadius: theme.spacing(GROUP_MARGIN),
    },
    toggleButton: {
        borderRadius: `${theme.spacing(GROUP_MARGIN)} !important`,
    },
}));
const ToggleButtonGroup = withStyles_1.default((theme) => ({
    grouped: {
        margin: theme.spacing(GROUP_MARGIN),
        border: 'none',
        '&:not(:first-child)': {
            borderRadius: theme.shape.borderRadius,
        },
        '&:first-child': {
            borderRadius: theme.shape.borderRadius,
        },
    },
}))(material_1.ToggleButtonGroup);
/**
 * Component for changing the calendar mode
 * @param props - ICalendarModeProps
 * @returns CalendarMode
 */
exports.CalendarMode = (props) => {
    const { onChangeMode, mode: currentMode } = props;
    const [mode, setMode] = react_1.useState(currentMode);
    const classes = useStyles();
    const handleMode = (value) => {
        if (value) {
            setMode(value);
            onChangeMode(value);
        }
    };
    return (react_1.default.createElement(material_1.Paper, { elevation: 0, className: classes.paper },
        react_1.default.createElement(ToggleButtonGroup, { value: mode, onChange: (_e, value) => handleMode(value), size: "small", exclusive: true }, Object.keys(calendar_mode_1.CalendarModeEnum).map(key => {
            const value = calendar_mode_1.CalendarModeEnum[key];
            return (react_1.default.createElement(material_1.ToggleButton, { className: classes.toggleButton, key: key, value: value, "aria-label": value, id: `calendar-mode-${key}` }, value));
        }))));
};
//# sourceMappingURL=data:application/json;base64,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